import { useTranslation } from 'react-i18next';
import { buildPatientNameLine } from 'utils/visitReasonDisplay';
import {
  ChiefComplaint,
  PatientInfoContainer,
  PatientInfoContent,
  PatientName,
  VisitReasonChip,
} from './PatientInfo.styles';

interface PatientInfoProps {
  patientName?: string;
  birthdate?: string;
  medatixxId?: string;
  visitReasonShort?: string | null;
  chiefComplaint?: string | null;
}

export const PatientInfo = ({
  patientName,
  birthdate,
  medatixxId,
  visitReasonShort,
  chiefComplaint,
}: PatientInfoProps) => {
  const { t } = useTranslation();
  const nameLine = patientName
    ? buildPatientNameLine(patientName, birthdate, medatixxId)
    : t('home.unknownPatient');

  return (
    <PatientInfoContainer>
      <PatientInfoContent>
        <PatientName>{nameLine}</PatientName>
        {chiefComplaint && <ChiefComplaint>{chiefComplaint}</ChiefComplaint>}
      </PatientInfoContent>
      {visitReasonShort && (
        <VisitReasonChip>{t(`home.visitReasons.${visitReasonShort}`)}</VisitReasonChip>
      )}
    </PatientInfoContainer>
  );
};
